module.exports = __webpack_public_path__ + "img/pr-9.0014dde0.png";